import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {getAllCountryFailure, getAllCountrySuccess} from '../../actions/publicActions/getAllCountryActions';

function* getAllCountry({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllCountry,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_COUNTRAY_SUCCESS status :", response.data.status);
        console.log("GET_ALL_COUNTRAY_SUCCESS data :", response.data.response);
        console.log("GET_ALL_COUNTRAY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllCountrySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_COUNTRAY_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_COUNTRAY_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_COUNTRAY_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllCountryFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllCountrySaga() {
    yield takeLatest(actionTypes.GET_ALL_COUNTRAY_REQUEST, getAllCountry);
}

export default getAllCountrySaga;
